export default "__VITE_ASSET__$omnFDsV__"